import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `/public-users`
};


function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    
    getNewUsers: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/new-user/chart`, {
        params: params
      });
    },
    
    getTotalCount: (data: RequestData) => {
      return HttpRequest.get(`${getUrl()}/total`);
    },
    
    getDeviceReport: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/device-report`, {
        params: params
      });
    },
    
    getUserDevices: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/devices`);
    },
    
    getUserAccessTokens: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/access-tokens`);
    },
    
    getUserLastLoginData: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/last-login`);
    },
    
    getUserSubscriptions: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/subscriptions`, {
        params
      });
    },
    
    getUserPurchases: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/purchases`, {
        params
      });
    },
    
    getUserContentWatch: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/content-watch`, {
        params
      });
    },
    
  };
}

export default api();
